"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _axios = _interopRequireDefault(require("axios"));
var _queryString = _interopRequireDefault(require("query-string"));
var _infoAZ = _interopRequireDefault(require("../../services/infoAZ"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _searchField = _interopRequireDefault(require("../../components/search-field"));
var _sectionFilter = _interopRequireDefault(require("../../components/section-filter"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
var _searchButton = _interopRequireDefault(require("./search-button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    paddingLeft: "40px",
    [theme.breakpoints.up("xl")]: {
      paddingLeft: 0
    }
  },
  linksWrapper: {
    columnGap: theme.spacing(6),
    display: "grid",
    gridTemplateColumns: "1fr",
    padding: theme.spacing(1, 0),
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr"
    }
  },
  linkItem: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    "& a": {
      alignItems: "center",
      color: theme.palette.text.primary,
      display: "flex",
      padding: theme.spacing(1.5, 1)
    },
    "& a:hover": {
      color: theme.palette.secondary.main
    },
    [theme.breakpoints.down("md")]: {
      "&:last-child": {
        borderBottom: 0
      }
    }
  },
  linkArrowIcon: {
    marginLeft: "auto"
  }
}));
const Links = _ref => {
  let {
    data,
    lang,
    providers
  } = _ref;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.linksWrapper,
    container: true
  }, data === null || data === void 0 ? void 0 : data.map(_ref2 => {
    let {
      count = 0,
      id,
      title
    } = _ref2;
    if (count === 0) return null;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.linkItem,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: "/".concat(lang, "/info-az/group/").concat(id).concat(providers ? "?providers=".concat(providers) : "")
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.linkArrowIcon,
      src: "/img/icons/arrow-right.svg",
      color: "primary",
      size: 20
    })));
  }));
};
const LayoutInfoAZ = _ref3 => {
  var _queryString$parse$pr, _queryString$parse, _data$data;
  let {
    match,
    location
  } = _ref3;
  const {
    lang
  } = match.params;
  const {
    search
  } = location;
  const {
    REACT_APP_PATH
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const [providers] = (0, _react.useState)((_queryString$parse$pr = (_queryString$parse = _queryString.default.parse(search)) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.providers) !== null && _queryString$parse$pr !== void 0 ? _queryString$parse$pr : "");
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const history = (0, _reactRouterDom.useHistory)();
  const theme = (0, _styles.useTheme)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 ? void 0 : pageData.theme) === "grey" && (pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.infoAZ")) {
      return;
    }
    const additionalPageData = {
      ...pageData,
      theme: "grey"
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.infoAZ")
      }
    };
    setPageData(additionalPageData);
  }, [pageData, setPageData, t]);
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListInfoFilter.api?lang=").concat(lang).concat(providers ? "&providers=".concat(providers) : "");
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-info-filter", lang, providers], () => _axios.default.get(url));
  if (status !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const handleChange = item => {
    history.push("/".concat(lang, "/info-az/letter/").concat(item.value).concat(providers ? "?providers=".concat(providers) : ""));
  };
  const handleSearch = value => {
    var _value$title;
    history.push("/".concat(lang, "/info-az/search/").concat((_value$title = value === null || value === void 0 ? void 0 : value.title) !== null && _value$title !== void 0 ? _value$title : "").concat(providers ? "?providers=".concat(providers) : ""));
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root,
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_sectionFilter.default, {
    allOptions: _infoAZ.default,
    onChange: handleChange
  }, /*#__PURE__*/_react.default.createElement(_searchButton.default, {
    lang: lang
  })), /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.searchFor")
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 2,
    mt: 2.5
  }, /*#__PURE__*/_react.default.createElement(_searchField.default, {
    background: theme.palette.common.white,
    placeholder: t("site.ui.search.placeholders.enterQuery"),
    onChange: handleSearch
  })), data && /*#__PURE__*/_react.default.createElement(Links, {
    data: data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.groups) === null || _data$data === void 0 ? void 0 : _data$data.items,
    lang: lang,
    providers: providers
  }));
};
var _default = exports.default = LayoutInfoAZ;